export default {
    state: {
      // message type: {message:"",type:"", others}
      flash_messages: [],
    },
    mutations: {
      SET_MESSAGES(state, payload) {
        state.flash_messages = payload;
      },
      CLEAR_ALL_MESSAGES(state, payload) {
        state.flash_messages = [];
      },
      CLEAR_MESSAGE(state, idx) {
        state.flash_messages.splice(idx, 1);
        state.flash_messages = [...state.flash_messages];
      }
    },
    getters: {
      getAllFlashMessages(state) {
        return state.flash_messages;
      }
    },
    actions: {
      addFlashMessages(context, flash_messages=[]) {
        let start_idx = context.state.flash_messages.length;
        context.commit("SET_MESSAGES", [...context.state.flash_messages, ...flash_messages]);
        return start_idx;
      },
      removeAllFlashMessages(context) {
        context.commit("CLEAR_ALL_MESSAGES");
      },
      removeFlashMessage(context, idx) {
        context.commit("CLEAR_MESSAGE", idx);
      },
      async handleHttpErrorResponse(context, response){
        let message = "";
        if (!response || [401,404,503,505].includes(response.status)) {
          message = "Something went wrong. Please try again."
        }
        else{
          const responseData = response.data.data || response.data;
          if (responseData) {
            message = typeof responseData === typeof {} ? responseData.error_description : responseData;
          } else {
            message = 'Something went wrong. Please try again.';
          }
        }
        return message;
      }
    },
  };